module.exports = __webpack_public_path__ + "img/ct-box.597dcd4b.png";